export default {
  labelCancelButton: 'キャンセル',
  labelAction: '操作',
  labelEdit: '編集',
  labelDelete: '削除',
  labelRegister: '登録',
  labelInputRequired: '入力必須です。',
  labelLengthExceeded: '{max}文字以内で入力してください。',
  labelNoAppointmentBtn: 'その他の<br />お客様',
  labelDefaultAppointments: '本日の予約一覧',
  labelVisitorDialog: 'お客様の会社名／お名前／ご用件をご入力ください。',
  labelVisitorName: '会社名／お名前',
  labelVisitorReason: 'ご用件',
  visitReasonOther: 'その他',
  labelCallButton: '呼出',
  waitingForWIFIMessage: 'WIFIの接続を待っています......',
  loadingMessage: '起動中......',
  loadingErrorMessage:
    'アプリケーションを終了し、問題が解決してから再起動してください。',
  callingMessage: '呼び出し中です。少々お待ちください。',
  visitorNotifyMessage: '{name}様が{reason}のためにいらっしゃいました。',
  errorReasonLogin: 'サーバーにログインできませんでした。',
  errorReasonServerConnection: 'サーバーとの通信中にエラーが発生しました。',
  errorReasonRegularButtonSettings:
    '常時表示ボタンの設定を取得できませんでした。',
  errorReasonReservationSettings: '予約情報の設定を取得できませんでした。',
  errorReasonDisplaySettings: '表示設定を取得できませんでした。',
  errorReasonPutDisplaySettings: '表示設定を更新できませんでした。',
  errorReasonVoiceSettings: '音声情報の設定を取得できませんでした。',
  errorReasonPostReservation: '予約情報を登録できませんでした。',
  errorReasonPutReservation: '予約情報を更新できませんでした。',
  errorReasonDeleteReservation: '予約情報を削除できませんでした。',
  errorReasonOther: 'エラーが発生しました。',
  errorReasonNoValidContracts: '有効な契約が見つかりませんでした。',
  labelEditPageTitle: "Touch'n Call 設定",
  labelGeneralSettings: '全般設定',
  descriptionGeneralSettings:
    '受付画面のタイトル、背景、予約表示部のタイトルを設定します。',
  labelRegularsSettings: '常時表示ボタン設定',
  descriptionRegularsSettings:
    '常時表示するボタンに関する、レイアウト、画像、タイトル、呼び出し用メッセージを設定します。',
  labelReservationsManage: '予約管理',
  descriptionReservationsManage: '予約の新規登録／変更／削除を行います。',
  labelCallingSettings: '呼出設定',
  descriptionCallingSettings:
    '呼び出し画面の表示時間、Microsoft Teamsへの通知に関する項目を設定します。',
  labelNoAppointmentSettings: 'その他のお客様の受付設定',
  descriptionNoAppointmentSettings:
    'その他のお客様用の、受付画面の表示項目を設定します。',
  labelCountOfButtons: 'ボタン数',
  labelDisplayType: '表示タイプ',
  itemDisplayTypeImage: '画像のみ',
  itemDisplayTypeImageLabel: '画像＋テキスト',
  itemDisplayTypeLabel: 'テキストのみ',
  labelDisplayText: '表示テキスト',
  labelVoiceMessage: '呼び出しメッセージ',
  labelGenerateVoice: '音声生成',
  labelSave: '保存',
  labelDisplayImage: '表示画像',
  pleaseSelectAnyButtonToEdit: '設定を変更したいボタンを選択してください。',
  labelHome: 'ホーム',
  labelReservationDate: '予約日時',
  labelReservationDisplayPeriod: '表示期間',
  labelReservationCreateButton: '新しい予約を作成',
  labelNoReservation: '登録済みの予約がありません。',
  labelConfirmReservationDeleting: 'この予約を削除してもよろしいですか？',
  labelReservationEdit: '予約の編集',
  labelReservationCreate: '予約の登録',
  labelReservationSpecifyTime: '時刻を設定する',
  labelReservationSpecifyPeriod: '表示期間を設定する',
  labelReservationBeginDate: '開始日時',
  labelReservationEndDate: '終了日時',
  speakerSearchingMessage: 'スマートスピーカー探索中......',
  labelSpeakerSelect: 'スマートスピーカー選択',
  labelSpeakerNotFound: 'スマートスピーカーが見つかりませんでした',
  labelSpeakerTable: '探索結果',
  labelVoiceTestButton: '音声テスト',
  labelSearchRetryButton: '再探索',
  labelToReceptViewButton: '受付画面へ',
  noAppointmentToday: '本日の予約はありません',
  labelCallingDisplayTime: '呼び出し中画面の表示時間',
  labelCallingDisplayTimeUnit: '秒',
  labelTeamsSettings: 'Microsoft Teamsの通知設定',
  labelTeamsNotifyUrl: '通知URL',
  labelTeamsNotifyTitle: '通知タイトル文字列',
  labelTeamsNotifyColor: '通知色',
  labelTeamsNotifyFormat: '通知フォーマット',
  labelTeamsNotifyFormatHint:
    '「{message}」は実際のメッセージに置き換わって通知されます。',
  labelBackgroundColor: '背景色',
  labelReceptionTitle: '受付タイトル文字列',
  labelReservationTitle: '本日の予約一覧タイトル文字列',
};
